
export enum ShipmentItemTypeCd {
	CUSTOMER = 'Customer',
	SHIPMENT = 'Shipment'}
